import React, { FC, useMemo } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import './richTextContent.scss';

const ALLOWED_TAGS = ['em', 'u', 'a', 'ul', 'ol', 'li', 'br', 'strong', 'p'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

// Rich text editor content (event/conference description, speaker bio, company info) is
// sanitized then parsed into a React element tree instead of using dangerouslySetInnerHTML.
const RichTextContent: FC = ({ children }) => {
  const sanitizedContent = useMemo(() => {
    const html = children ? String(children).replace(/<p>\s*<\/p>/gi, '<br>') : '';
    return html ? DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR }) : '';
  }, [children]);

  if (!sanitizedContent) return null;

  return <span className="rich-text-content">{parse(sanitizedContent)}</span>;
};

export default RichTextContent;
